import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M8 9h8m-4 0v8","key":"svg-1"}]]

const IconBrandThingiverse = createReactComponent('outline', 'brand-thingiverse', 'BrandThingiverse', __iconNode);

export default IconBrandThingiverse;